import React, {FC} from 'react'

import cn from 'classnames/bind'
import Image from 'next/legacy/image'

import LandingsTitle from 'components/blocks/LandingsTitle/LandingsTitle'
import {Container} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2TipsWhenSeveral.module.scss'
const cx = cn.bind(s)

interface IW2TipsWhenSeveralProps {
	className?: string
	content: IW2Content['tipsWhenSeveral']
}

/** W2TipsWhenSeveral block component */
const W2TipsWhenSeveral: FC<IW2TipsWhenSeveralProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				<ul className={s.list}>
					{content?.items?.map((item) => (
						<li className={s.item} key={item._key}>
							<div className={cx('item__figure')}>
								<Image
									className={s.icon}
									layout="fixed"
									src={(item.icon as unknown as string) || ''}
									width="88"
									height="88"
									alt={`icon`}
								/>
							</div>

							<p className={cx('item__description')}>{item.text}</p>
						</li>
					))}
				</ul>
			</Container>
		</div>
	)
}

W2TipsWhenSeveral.displayName = 'W2TipsWhenSeveral'

export default W2TipsWhenSeveral
